export default __webpack_public_path__ + "static/media/Lab_Partner_4_PCR_Product.e36b637e.svg";